import {
  countryCodeFound,
  getCountryNameByCode,
  getCountryObjectByCode,
  appendMapTooltip,
  modMap,
  modMapColorBorder,
  regionStyle} from './helper';

  jQuery(function($){
  if ($('#project-map').length > 0) {
    // const baseUrl = $('#base-url').data('base-url');

    console.log('project-map Ready');

    var theMap = $("#project-map");
    const tip = $(".map-tooltip");

    const countriesData =  theMap.data('json');

    console.log('countriesData', countriesData);

    let timeoutVar;

    theMap.vectorMap({
      map: "world_mill",
      backgroundColor: "#F9F9FB",
      panOnDrag: true,
      zoomAnimate: true,
      zoomOnScroll: false,
      // focusOn: {region: countryCodes},
      regionStyle: regionStyle,
      onRegionClick: function (e, code) {
        const countryObj = getCountryObjectByCode(countriesData, code);

        window.location = countryObj.permalink;
      },
      onRegionOver: function (e, code) {
        e.preventDefault();

        if (countryCodeFound(countriesData, code)) {
          const countryName = getCountryNameByCode(countriesData, code);

          let content = {};

          content.title = countryName;
          content.footer = '(Click to view country page)';
          appendMapTooltip(tip, content);

          tip.css('position', 'fixed');
          tip.show();

          e.target.addEventListener("mousemove", tooltipMousemove);
        }
      },
      onRegionOut: function (e, code) {
        e.preventDefault();
        const tip = $(".map-tooltip");

        tip.hide();

        e.target.removeEventListener("mousemove", tooltipMousemove);
      },
      onRegionTipShow: function (e) {
        e.preventDefault();
        return false;
      },
      onViewportChange: function (e, scale) {
        e.preventDefault();
      },
      onMarkerTipShow: function(e, o, s) {
        e.preventDefault();
      },
      onMarkerClick: function(e, index){
        e.preventDefault();
      },
      onMarkerOver: function(e, s) {
        e.preventDefault();
      },
      onMarkerOut: function(e, s) {
        e.preventDefault();
      }
    });

    function tooltipMousemove(e) {
      let top = window.pageYOffset || document.documentElement.scrollTop;
      const tip = $('.map-tooltip');

      tip.css("top", e.pageY - top + "px");
      tip.css("left", e.pageX + "px");
    }

    var myMap = theMap.vectorMap("get", "mapObject");

    let countryCodes = [];

    const validCountryCodes = countriesData.filter((country, index) => {
      return myMap.regions[country.country_code] !== undefined;
    });

    validCountryCodes.map((country, index) => {
      myMap.regions[country.country_code].element.config.style.selected.fill = '#004587';
      myMap.setSelectedRegions(country.country_code);
      countryCodes.push(country.country_code);
    });

    myMap.setFocus({'regions': countryCodes});

    modMap(theMap);
    modMapColorBorder(theMap);

    $(window).on('resize', function(){
      const ww = $(window).width();

      clearTimeout(timeoutVar);

      timeoutVar = setTimeout(() => {
        myMap.setFocus({'regions': countryCodes});
      }, 100);
    });
  } // if END
});
